import { DateRangeIssue, DateRangeConstraints } from './dateRange.types';

export function validateDateRange(
  start: Date | null,
  end: Date | null,
  constraints?: DateRangeConstraints
): DateRangeIssue[] {
  const issues: DateRangeIssue[] = [];

  // Required
  if (!start && !end) {
    issues.push({ field: 'range', severity: 'error', code: 'START_AND_END_REQUIRED' });
  }

  if (!start) {
    issues.push({ field: 'start', severity: 'error', code: 'START_REQUIRED' });
  }

  if (!end) {
    issues.push({ field: 'end', severity: 'error', code: 'END_REQUIRED' });
  }

  // Logical ordering
  if (start && end && start > end) {
    issues.push(
      { field: 'range', severity: 'error', code: 'START_AFTER_END' },
      { field: 'start', severity: 'error', code: 'START_AFTER_END' },
      { field: 'end', severity: 'error', code: 'START_AFTER_END' },
    );
  }

  // Hard bounds — start
  if (constraints?.hardMinStart && start && start < constraints.hardMinStart) {
    issues.push({
      field: 'start',
      severity: 'error',
      code: 'START_BEFORE_HARD_MIN',
    });
  }

  if (constraints?.hardMaxEnd && start && start > constraints.hardMaxEnd) {
    issues.push({
      field: 'start',
      severity: 'error',
      code: 'START_AFTER_HARD_MAX',
    });
  }

  // Hard bounds — end
  if (constraints?.hardMaxEnd && end && end > constraints.hardMaxEnd) {
    issues.push({
      field: 'end',
      severity: 'error',
      code: 'END_AFTER_HARD_MAX',
    });
  }

  if (constraints?.hardMinStart && end && end < constraints.hardMinStart) {
    issues.push({
      field: 'end',
      severity: 'error',
      code: 'END_BEFORE_HARD_MIN',
    });
  }

  // Soft bounds (warnings)
  if (constraints?.softMinStart && start && start < constraints.softMinStart) {
    issues.push({
      field: 'start',
      severity: 'warning',
      code: 'START_BEFORE_SOFT_MIN',
    });
  }

  if (constraints?.softMaxEnd && end && end > constraints.softMaxEnd) {
    issues.push({
      field: 'end',
      severity: 'warning',
      code: 'END_AFTER_SOFT_MAX',
    });
  }

  return issues;
}
